
import { defineComponent } from 'vue';
import FbxButton from './fbx-button.vue';

export default defineComponent({
    components: {
        FbxButton,
    },
    emits: ['onNavigateBack', 'onSubmit'],
    props: {
        isSubmitDisabled: {
            type: Boolean,
        },
    },
});
